__webpack_require__.p = "/yt-live/";